import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';

export const FlexBetween: FC<BoxProps> = ({ children, ...props }) => (
  <Box display="flex" justifyContent="space-between" alignItems="center" {...props}>
    {children}
  </Box>
);
